import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Play } from "lucide-react";

export default function AdminQueues() {
    const [q, setQ] = useState(null);
    const [enriching, setEnriching] = useState(false);

    const load = () => {
        api.get("/admin/queues").then(({ data }) => setQ(data));
    };
    useEffect(() => {
        load();
        const h = setInterval(load, 5000);
        return () => clearInterval(h);
    }, []);

    const enrichAll = async () => {
        setEnriching(true);
        try {
            const { data } = await api.post("/admin/ai/enrich-queue");
            toast.success(`${data.queued} vini in coda`);
            load();
        } catch {
            toast.error("Errore avvio coda");
        } finally {
            setEnriching(false);
        }
    };

    if (!q) return <div className="text-[hsl(var(--muted-foreground))]">Caricamento…</div>;

    return (
        <div data-testid="admin-queues-page">
            <h1 className="text-3xl mb-6">Code di Lavorazione</h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <Card title="Arricchimento AI">
                    <Row label="Da arricchire" value={q.enrichment.da_arricchire} highlight />
                    <Row label="In validazione" value={q.enrichment.in_validazione} />
                    <Row label="Validati" value={q.enrichment.validati} />
                    <button
                        onClick={enrichAll}
                        disabled={enriching || q.enrichment.da_arricchire === 0}
                        className="co-btn-primary mt-4 w-full"
                        data-testid="queue-enrich-all-btn"
                    >
                        <Play className="w-4 h-4" /> {enriching ? "Avvio…" : `Arricchisci tutti (${q.enrichment.da_arricchire})`}
                    </button>
                </Card>
                <Card title="Immagini">
                    <Row label="Senza" value={q.images.senza} highlight />
                    <Row label="Automatiche" value={q.images.auto} />
                    <Row label="Manuali" value={q.images.manuali} />
                    <div className="mt-4 pt-3 border-t border-[hsl(var(--border))] text-xs text-[hsl(var(--muted-foreground))]">
                        Ricerca automatica: {q.cse.allowed ? "attiva" : "non disponibile"} ·
                        oggi {q.cse.used_today}/{q.cse.quota}
                    </div>
                </Card>
                <Card title="Merge Proposals">
                    <Row label="Pendenti" value={q.merge_proposals_pending} highlight={q.merge_proposals_pending > 0} />
                </Card>
            </div>
        </div>
    );
}

function Card({ title, children }) {
    return (
        <div className="bg-white border border-[hsl(var(--border))] rounded-sm p-5">
            <h2 className="text-xl mb-4">{title}</h2>
            <div className="space-y-2">{children}</div>
        </div>
    );
}

function Row({ label, value, highlight }) {
    return (
        <div className="flex items-center justify-between text-sm">
            <span className="text-[hsl(var(--muted-foreground))]">{label}</span>
            <span className={highlight ? "text-[hsl(var(--primary))] text-lg" : ""}>{value}</span>
        </div>
    );
}
